import { useGLTF } from '@react-three/drei'; // useProgress
import { useFrame } from '@react-three/fiber';
import { useContext, useEffect, useRef, useState } from 'react';

import season_window from '@/assets/models/season_window.glb';
import { GameContext } from '@/state/contexts';

const SeasonWindow = () => {
	const scl = 0.04;
	const initX = 1.35;
	const initY = 5.5;
	const initZ = 8.75;

	const { seasonTracker }: any = useContext(GameContext);
	const objectRef: any = useRef(null);
	const [targetPosition, setTargetPosition] = useState([initX, initY, initZ]);

	useEffect(() => {
		const targetX = initX + 2.4 * seasonTracker;
		const targetY = initY;
		const targetZ = initZ;

		setTargetPosition([targetX, targetY, targetZ]); // Update target position array
	}, [seasonTracker]);

	useFrame(() => {
		if (objectRef.current) {
			const [targetX, targetY, targetZ] = targetPosition;
			const currentPos = objectRef.current.position;

			const movementSpeed = 0.025; // Control speed of the slide

			// Interpolate towards target positions (x, y, z)
			if (
				Math.abs(currentPos.x - targetX) > 0.01 ||
				Math.abs(currentPos.y - targetY) > 0.01 ||
				Math.abs(currentPos.z - targetZ) > 0.01
			) {
				currentPos.x += (targetX - currentPos.x) * movementSpeed;
				currentPos.y += (targetY - currentPos.y) * movementSpeed;
				currentPos.z += (targetZ - currentPos.z) * movementSpeed;
			}
		}
	});

	const {
		nodes,
		// materials
	} = useGLTF(season_window);

	return (
		<group ref={objectRef}>
			<primitive
				object={nodes.season_window}
				scale={[scl, scl + 0.05, scl]}
			/>
		</group>
	);
};

useGLTF.preload(season_window);

export default SeasonWindow;
